module.exports = __webpack_public_path__ + "img/octopus-product.fc5d59cb.png";